<template>
    <div class="row">
        <div :class="$store.state.role == 'organization' || $store.state.role == 'tourismorg' ? 'col-md-6' : 'col-md-12'">
            <div class="card mb-3">
                <form class="card-body" @submit.prevent="submitImage">
                    <Loading v-if="showImageLoading" />
                    <div class="alert alert-info">
                        <p class="mb-0">تصویر مورد نظر خود (جهت چاپ بر روی کارت) را آپلود کنید</p>
                    </div>
                    <div class="form-group">
                        <div class="input-group file-browser">
                            <input type="text" class="form-control border-left-0 browse-file" id="file" placeholder="انتخاب کنید" readonly="">
                            <label class="input-group-btn mb-0">
                                <span class="btn btn-primary">
                                    انتخاب کردن <input type="file" style="display: none" @change="setFileData" accept="image/jpeg,image/png">
                                </span>
                            </label>
                        </div>
                    </div>
                    <img :src="image" v-if="image" style="display: block;margin: 20px auto;width: 350px">
                    <button class="btn btn-success" type="submit" :disabled="image == ''">ثبت و ذخیره تصویر</button>
                </form>
            </div>
        </div>
        <div class="col-md-6" v-if="$store.state.role == 'organization' || $store.state.role == 'tourismorg'">
            <div class="card mb-3">
                <div class="card-body">
                    <Loading v-if="showTextLoading" />
                    <div class="alert alert-info">
                        <p class="mb-0">متن دلخواه مورد نظر خود (جهت چاپ بر روی کارت) را وارد کنید</p>
                    </div>
                    <form @submit.prevent="submitText">
                        <div class="form-group">
                            <label>متن</label>
                            <input type="text" class="form-control" v-model="text" v-on:keyup="textChecker">
                        </div>
                        <button class="btn btn-success" type="submit" :disabled="!text.trim()">ثبت و ذخیره متن</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Base64 } from '@/utils';

export default {
    name: 'AddData',
    data(){
        return {
            showImageLoading: false,
            showTextLoading: false,
            text: '',
            image: ''
        }
    },
    methods: {
        submitImage(){
            this.showImageLoading = true;
            const postedData = {
                base64: this.image,
                key: 2
            };
            this.$api.post('Organizations/Media',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'تصویر مورد نظر شما با موفقیت آپلود شد و در صف بررسی توسط ' + (this.$store.state.role == 'branches' || this.$store.state.role == 'izbank-admin' ? 'روابط عمومی' : 'ادمین') + ' قرار گرفت',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.image = '';
                    document.getElementById('file').setAttribute('placeholder','انتخاب کنید');
                }
            }).finally(() => {
                this.showImageLoading = false;
            });
        },
        textChecker(){
            this.text = this.text.replace(/[0-9]/g,'');
        },
        submitText(){
            this.showTextLoading = true;
            const postedData = {
                base64: 'data:text/plain;base64,' + Base64.encode(this.text),
                key: 3
            };
            this.$api.post('Organizations/Media',postedData).then(({data}) => {
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'متن مورد نظر شما با موفقیت ثبت شد و در صف بررسی توسط ادمین قرار گرفت',
                        confirmButtonText: 'متوجه شدم'
                    }).then(() => {
                        this.$router.push({name: 'organization.dataList'});
                    });
                    this.text = '';
                }
            }).finally(() => {
                this.showTextLoading = false;
            });
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setFileData(e){
            const file = e.target.files[0];
            if(file.size > 1000000){
                this.$swal({
                    title: 'خطا',
                    icon: 'error',
                    text: 'حجم عکس نمی تواند بیشتر از 1 مگابایت باشد'
                });
                document.getElementById('file').setAttribute('placeholder','انتخاب کنید');
                this.image = '';
            }else{
                const finalFile = await this.toBase64(file);
                this.image = finalFile;
                document.getElementById('file').setAttribute('placeholder',file.name);
            }
        }
    }
}
</script>